import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { NEVER } from 'rxjs';
import { DefaultHttpService } from '@arematics/core/api';
import * as i1 from '@angular/common/http';
import * as i2 from '@arematics/keycloak-angular';

class OrganisationService extends DefaultHttpService {
    auth;
    constructor(http, environment, auth) {
        super(environment.orga_api, http);
        this.auth = auth;
    }
    fetchById(uuid) {
        return this.client().get(this.root + 'organization/' + uuid);
    }
    fetchOwned() {
        const uuid = this.auth.getKeycloakInstance().profile?.id;
        if (uuid) {
            return this.client().get(this.root + 'organization/owned');
        }
        else {
            return NEVER;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrganisationService, deps: [{ token: i1.HttpClient }, { token: 'environment' }, { token: i2.KeycloakService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrganisationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrganisationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['environment']
                }] }, { type: i2.KeycloakService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { OrganisationService };
